module.exports = __webpack_public_path__ + "img/logo_member_topen_id.72fda0b1.gif";